import { NgClass } from '@angular/common'
import { Component, input } from '@angular/core'
import { TrackerStatusRow } from '../../../../../helpers/delivery-status-help'

@Component({
  selector: 'app-delivery-status-table',
  standalone: true,
  imports: [NgClass],
  templateUrl: './delivery-status-table.component.html',
  styleUrl: './delivery-status-table.component.scss'
})
export class DeliveryStatusTableComponent {
  public readonly rows = input.required<readonly TrackerStatusRow[]>()

  /**
   * Returns the class names for a table row.
   * @param odd - Whether the row index is odd.
   */
  public rowClass(odd: boolean): Record<string, boolean> {
    return {
      'tw-bg-gray-50': odd,
      'tw-bg-white': !odd
    }
  }
}
